import { ManualContext } from '@f_qwep/context/Manual_context';
import { GroupContext } from '@f_qwep/context/Group_context';
import { SettingsContext } from '@f_qwep/context/Settings_context';
import React, { useContext, useEffect, useRef, useState } from 'react';
import GeneralJoyride from '../GeneralJoyride';
import { QwepContext } from '@f_qwep/context/Qwep_context';
import { Alert } from '@f_general/alert';
import { useWindowSize } from '@f_hooks/index';
import { IconMaskot } from '@f_components/icons/IconMascot';

export function EditGroupsAccountsManual() {
    const { selectedPageName, setSelectedPageName, open } = useContext(SettingsContext);
    const { setChooseManual, newManualValue, setNewManualValue } = useContext(ManualContext);
    const { groupsAccountsState, receivedResponse } = useContext(QwepContext);

    const [run, setRun] = useState(false);

    const [currentStep, setCurrentStep] = useState(0);

    const { openEditId, setOpenEditId, openId, setOpenId } = React.useContext(GroupContext);

    const [steps, setSteps] = useState<any>([
        {
            target: '#settings',
            content: (
                <div>
                    <IconMaskot />
                    <p>Перейдите в раздел "Настройки"</p>
                </div>
            ),
            disableBeacon: true,
            hideFooter: true,
            spotlightClicks: true,
        },
        {
            target: '#menuButtonSettings',
            content: 'Откройте меню настроек',
            disableBeacon: true,
            hideFooter: true,
            spotlightClicks: true,
        },
        {
            target: '#group_accounts',
            content: 'Далее в раздел "Группы поставщиков"',
            disableBeacon: true,
            hideFooter: true,
            spotlightClicks: true,
            placement: 'right',
        },
        {
            target: '#editGroupsAccounts',
            title: 'Редактирование группы поставщиков',
            content: 'Нажмите, чтобы приступить к редактированию',
            disableBeacon: true,
            hideFooter: true,
            spotlightClicks: true,
        },
        {
            target: '#checkboxEdit0',
            content: 'Управляйте активностью поставщиков переключая флажок',
            disableBeacon: true,
            hideFooter: false,
            spotlightClicks: false,
        },
        {
            target: '#closeIconEdit',
            content: 'Нажмите, чтобы удалить поставщика из группы',
            disableBeacon: true,
            hideFooter: false,
            spotlightClicks: false,
        },
        {
            target: '#expandGroupAccount',
            title: 'Добавление новых поставщиков в группу поставщиков',
            content: 'Нажмите, чтобы развернуть группу',
            disableBeacon: true,
            hideFooter: true,
            spotlightClicks: true,
        },
        {
            target: '#addNewAccounts',
            content: 'Нажмите, чтобы добавить новых поставщиков в группу',
            disableBeacon: true,
            hideFooter: false,
            spotlightClicks: false,
        },
    ]);

    const { width } = useWindowSize();

    useEffect(() => {
        if (window.location.pathname == '/app-qwep/' || window.location.pathname == '/app-qwep') {
            if (groupsAccountsState?.length && receivedResponse) {
                setRun(true);
                setSelectedPageName('accounts');
                if (!newManualValue.settings?.flag) {
                    setNewManualValue({ ...newManualValue, settings: { flag: true } });
                }
            } else {
                Alert({
                    type: 'warning',
                    text: 'Для просмотра мануала сначала создайте группу поставщиков!',
                });
            }
        }
    }, [receivedResponse]);

    useEffect(() => {
        if (width) {
            if (currentStep == 1) {
                // const target = document.querySelector('#menuButtonSettings');
                if (width > 1200) {
                    setCurrentStep((prevStep) => prevStep + 1);
                } else {
                    if (open) {
                        setCurrentStep((prevStep) => prevStep + 1);
                    }
                }
            }
        }
    }, [currentStep, width, open]);

    useEffect(() => {
        if (window.location.pathname == '/app-qwep/settings') {
            setTimeout(() => {
                setCurrentStep((prevStep) => prevStep + 1);
            }, 100);
        } else if (window.location.pathname == '/app-qwep/settings/accounts') {
            setCurrentStep((prevStep) => prevStep + 1);
        }
    }, [window.location.pathname, selectedPageName]);

    useEffect(() => {
        if (openEditId || openId) {
            setCurrentStep((prevStep) => prevStep + 1);
        }
    }, [openEditId, openId]);

    const handleJoyrideCallback = (data: any) => {
        const { action, step, index, status, type } = data;

        if (type === 'step:after' && action === 'next' && !step.hideFooter) {
            setCurrentStep((prevStep) => prevStep + 1);
            if (width > 1200 ? currentStep == 5 : currentStep == 5) {
                setOpenEditId(null);
            }
        } else if (type === 'step:before') {
        } else if (
            type === 'step:after' &&
            (action === 'skip' || action === 'close' || action === 'last' || action === 'skip')
        ) {
            setCurrentStep(0);
            setRun(false);
            setChooseManual();
        }
    };

    return (
        <div>
            <GeneralJoyride steps={steps} run={run} callback={handleJoyrideCallback} stepIndex={currentStep} />
        </div>
    );
}
